var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Schedule',{attrs:{"id":_vm.id,"fields":_vm.fields,"data":_vm.data,"code":_vm.code,"config":_vm.config,"months":undefined,"tournDates":_vm.tournDates,"newReports":_vm.newReports}})
}
var staticRenderFns = []

export { render, staticRenderFns }